import { IItemScore } from "../../../base/common/fuzzyScorer";




export function fuzzyScoreSortingHelper(nameA: string | undefined | null, itemAScore: IItemScore | number, nameB: string | undefined | null, itemBScore: IItemScore | number): number {
    if (nameA && !nameB) return -1;
    if (!nameA && nameB) return 1;
    return (typeof itemBScore === "number" ? itemBScore : itemBScore.score) - (typeof itemAScore === "number" ? itemAScore : itemAScore.score);
}